import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PatientService } from '@app/_services/patient.service';
import { AlertService } from '@app/_services';
import {
  ShowOnDirtyErrorStateMatcher,
  ErrorStateMatcher,
} from '@angular/material/core';
import { Options } from '@angular-slider/ngx-slider';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  templateUrl: 'educate.component.html',
  styleUrls: ['educate.component.scss'],
})
export class EducateComponent {
  tiles = [
    {
      text: 'Your Sleep Environment',
      cols: 1,
      rows: 3,
      index: 5,
      img: '/assets/image_145.png',
    },
    {
      text: 'Introduction',
      cols: 1,
      rows: 3,
      index: 6,
      img: '/assets/ed1.png',
    },
    {
      text: 'Facts About Sleep',
      cols: 1,
      rows: 3,
      index: 7,
      img: '/assets/ed2.png',
    },
    {
      text: 'Sleep with Age',
      cols: 1,
      rows: 3,
      index: 8,
      img: '/assets/ed3.png',
    },    
	{
      text: 'What Controls Sleep',
      cols: 1,
      rows: 3,
      index: 9,
      img: '/assets/Rectangle_2823.png',
    },
    {
      text: 'Emotions & Physical Health',
      cols: 1,
      rows: 3,
      index: 10,
      img: '/assets/ed4.png',
    },
    {
      text: 'What is Insomnia',
      cols: 1,
      rows: 3,
      index: 11,
      img: '/assets/ed5.png',
    },
    {
      text: 'What Perpetutates Insomnia',
      cols: 1,
      rows: 3,
      index: 12,
      img: '/assets/ed6.png',
    },
  ];



  observed = [
    {
      text: 'Your Sleep Environment',
      cols: 1,
      rows: 3,
      index: 5,
      img: '/assets/image_145.png',
    },
    {
      text: 'Introduction',
      cols: 1,
      rows: 3,
      index: 6,
      img: '/assets/ed1.png',
    },  
    {
      text: 'Facts About Sleep',
      cols: 1,
      rows: 3,
      index: 7,
      img: '/assets/ed2.png',
    },
    {
      text: 'Sleep with Age',
      cols: 1,
      rows: 3,
      index: 8,
      img: '/assets/ed3.png',
    }
  ];

  mobile_observed = [
    {
      text: 'Your Sleep Environment',
      cols: 1,
      rows: 3,
      index: 5,
      img: '/assets/image_145.png',
    },
  ];
  observedmax = 4;
  observedmin = 0;
  currentPage = 5;
  changePage(page: number) {
    //do nothing validation:
    if (
      this.observedmax + page > this.tiles.length ||
      this.observedmin + page < 0
    )
      return;

    this.observedmax += page;
    this.observedmin += page;

    this.observed = [];
    for (let i = this.observedmin; i < this.observedmax; i++) {
      this.observed.push(this.tiles[i]);
    }
  }
  observedmax_mobile = 1;
  observedmin_mobile = 0;
  currentPage_mobile = 5;
  changePage_mobile(page: number) {
    //do nothing validation:
    if (
      this.observedmax_mobile + page > this.tiles.length ||
      this.observedmin_mobile + page < 0
    )
      return;

    this.observedmax_mobile += page;
    this.observedmin_mobile += page;

    this.mobile_observed = [];
    for (let i = this.observedmin_mobile; i < this.observedmax_mobile; i++) {
      this.mobile_observed.push(this.tiles[i]);
    }
  }
  /*currentLesson(lesson: number) {
    console.log(this.currentPage);
    this.currentPage = lesson;
    console.log(this.currentPage);
  }*/

  selectedActionPlanList: Array<number> = [1]
  maxStep;
  constructor(
    private patientService: PatientService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.patientService.fetchPatientPlanData()
      .subscribe({
        next: (data) => {
          data.results.forEach(item => {
            this.selectedActionPlanList.push(item.step_name)
          });

          if(!this.selectedActionPlanList.includes(this.currentPage)){
            this.currentLesson(this.currentPage);
          }
          this.maxStep = Math.max(...this.selectedActionPlanList);
        },
        error: (error) => {
          this.alertService.error(error);
        },
      });
  }



  currentLesson(lesson: number) {

    if (this.selectedActionPlanList.includes(lesson)) {
      this.currentPage = lesson
    } else {
      this.patientService.savePatientPlanData({
        "step_name": lesson
      }).subscribe({
        next: (data) => {
          this.selectedActionPlanList.push(lesson)
          this.maxStep = Math.max(...this.selectedActionPlanList);

          this.currentPage = lesson
        },
        error: (error) => {
          this.alertService.error(error);
        },
      });
    }

  }
}
